import { createContext } from 'react';
import { TUploaderContext } from './types';

const UploaderContext = createContext<TUploaderContext>({} as TUploaderContext);
UploaderContext.displayName = 'UploaderContext';

export default UploaderContext;
